/*
 * @class Oskari.mapframework.bundle.seutumaisaSearch.Tile
 *
 * Renders the "Seutumaisa search" tile.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.seutumaisaSearch.Tile',
/**
 * @method create called automatically on construction
 * @static
 * @param
 * {Oskari.mapframework.bundle.seutumaisaSearch}
 * instance
 *      reference to component that created the tile
 */
function (instance) {
  this.instance = instance;
  this.container = null;
  this.template = null;
  this.shownLayerCount = null;
}, {
  /**
   * Gets name
   * @method getName
   * @public
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.seutumaisaSearch.Tile';
  },
  /**
   * Interface method implementation
   * @method setEl
   * @public
   * @param {Object} el reference to the container in browser
   */
  setEl: function setEl(el) {
    this.container = jQuery(el);
  },
  /**
   * Interface method implementation, calls #refresh()
   * @method startPlugin
   * @public
   */
  startPlugin: function startPlugin() {
    this.createUI();
  },
  /**
   * Interface method implementation, clears the container
   * @method stopPlugin
   * @public
   */
  stopPlugin: function stopPlugin() {
    this.container.empty();
  },
  /**
   * Creates the UI for a fresh start
   * @method _createUI
   * @public
   */
  createUI: function createUI() {
    this.container.addClass('seutumaisa-search-tile');
  },
  /**
  * Gets tile
  * @method getTitle
  * @public
  * @return {String} localized text for the title of the tile
  */
  getTitle: function getTitle() {
    return this.instance.getLocalization('title');
  },
  /**
   * Gets description
   * @method getDescription
   * @public
   * @return {String} localized text for the description of the tile
   */
  getDescription: function getDescription() {
    return this.instance.getLocalization('desc');
  },
  /**
   * Interface method implementation, does nothing atm
   * @method getOptions
   * @public
   */
  getOptions: function getOptions() {},
  /**
   * Interface method implementation, does nothing atm
   * @method setState
   * @public
   * @param {Object} state state that this component should use
   */
  setState: function setState(state) {},
  /**
   * Creates the UI for a fresh start
   * @method refresh
   * @public
   */
  refresh: function refresh() {
    var me = this;
  },
  /**
   * Clears tile
   * @method clear
   */
  clear: function clear() {
    var me = this;
    me.refresh();
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  'protocol': ['Oskari.userinterface.Tile']
});